module.exports = __webpack_public_path__ + "assets/img/Android.8a391fb9.svg";